module.exports = {"data":{"site":{"siteMetadata":{"title":"m1x","tagline":"I design and build apps for humans.","keywords":["hello","these","are","my","tags"]}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 111
// module chunks = 60335399758886 114276838955818